import { Alert } from '@/components/ui/alert'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'
import { retentionPreviewRows, type RetentionPreviewCounts } from './retentionPreview'
import { connectionError } from './useAddConnection'

export function RetentionPreview({
  counts,
  loading,
  error,
  ready,
  checked,
  onCheck,
}: {
  counts?: RetentionPreviewCounts
  loading: boolean
  error: Error | null
  ready: boolean
  checked: boolean
  onCheck: (checked: boolean) => void
}) {
  return (
    <>
      {loading ? (
        <div role="status" aria-label="Loading retention preview" className="space-y-2">
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
          <Skeleton className="h-9 w-full" />
        </div>
      ) : error ? (
        <Alert>{connectionError(error)}</Alert>
      ) : counts ? (
        <RetentionCounts counts={counts} />
      ) : null}
      <div className="flex items-start gap-2">
        <Checkbox
          id="retention-ack"
          checked={checked}
          disabled={!ready}
          onCheckedChange={(value) => onCheck(value === true)}
        />
        <Label htmlFor="retention-ack">I understand these rows are removed for good</Label>
      </div>
    </>
  )
}
function RetentionCounts({ counts }: { counts: RetentionPreviewCounts }) {
  const visible = retentionPreviewRows.filter(({ key }) => counts[key] > 0)
  if (!visible.length)
    return (
      <div className="flex h-9 items-center border-y border-border text-body-sm text-muted-foreground">
        Next run removes nothing
      </div>
    )
  return (
    <dl className="m-0 border-t border-border">
      {visible.map(({ key, label }) => (
        <div key={key} className="flex h-9 items-center justify-between border-b border-border">
          <dt className="text-body-sm">{label}</dt>
          <dd className="m-0 text-right text-body-sm font-medium tabular-nums">
            {counts[key].toLocaleString('en-GB')}
          </dd>
        </div>
      ))}
    </dl>
  )
}
